<template>
  <div class="dropdown" v-if="currentUser" :key="reloadUser">
    <span class="dropdown-toggle"
      ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
        <path
          class="fa-secondary"
          opacity=".4"
          d="M16 482.3C16 392.7 88.7 320 178.3 320l91.4 0C359.3 320 432 392.7 432 482.3c0 7.6-6.1 13.7-13.7 13.7L29.7 496c-7.6 0-13.7-6.1-13.7-13.7zM336 128a112 112 0 1 1 -224 0 112 112 0 1 1 224 0z"
        />
        <path
          class="fa-primary"
          d="M336 128a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM16 482.3c0 7.6 6.1 13.7 13.7 13.7l388.6 0c7.6 0 13.7-6.1 13.7-13.7C432 392.7 359.3 320 269.7 320l-91.4 0C88.7 320 16 392.7 16 482.3zm-16 0C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3z"
        />
      </svg>
      {{ fullName }}</span
    >
    <div class="dropdown-content">
      <a class="dropdown-item" href="/blackbook/blackbook-main">Blackbook</a>
      <a class="dropdown-item" href="/marketplace/sales-data-products"
        >Marketplace</a
      >
      <a class="dropdown-item" href="/blackbook/profile">Update Details</a>
      <a class="dropdown-item" @click.prevent="logOut">Logout</a>
    </div>
  </div>
  <div class="dropdown" v-if="!currentUser" :key="reloadUser">
    <span>Account</span>
    <div class="dropdown-content">
      <a class="dropdown-item" href="/blackbook/">Blackbook</a>
      <a class="dropdown-item" href="/marketplace/">Marketplace</a>
    </div>
  </div>
  <!-- <li class="nav-item" v-if="!currentUser" :key="reloadUser">
    <a class="nav-link" href="/blackbook/">Blackbook</a>
    <a class="nav-link" href="/marketplace/">Marketplace</a>
  </li> -->
</template>

<script>
import store from "../store";
import AuthService from "../../../../breednet-blackbook-frontend/src/services/auth.service";
export default {
  store,
  name: "UserLogin",
  components: {},
  data() {
    return {
      fullName: "",
      reloadUser: 0,
    };
  },
  computed: {
    currentUser() {
      return store.state.auth.user;
    },
  },
  mounted() {
    if (this.currentUser) {
      this.fullName =
        Array.from(this.currentUser.firstName)[0].toUpperCase() +
        Array.from(this.currentUser.lastName)[0].toUpperCase();
    }
  },
  methods: {
    logOut() {
      AuthService.logout();
      //commit("logout");
      //this.$store.dispatch("auth/logout");
      //this.$router.push("https://www.breednet.com.au/");
      window.location.href = "/";

      this.reloadUser += 1;
    },
  },
};
</script>
<style scoped>
.btn-primary {
  background-color: #fff;
}
svg {
  width: 1.2rem;
  fill: #000;
  margin-right: 5px;
}
.user-icon::before {
  content: "\f007";
}
.dropdown {
  position: relative;
  display: block;
  color: rgba(0, 0, 0, 0.5);
  font-weight: 100;
  cursor: pointer;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  /* border: 1px solid #b1b0b0; */
}
.dropdown-toggle:after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.dropdown-content {
  display: none;
  position: absolute;
  left: 0;
  background-color: #fff;
  min-width: 10rem;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  z-index: 1000;
  list-style: none;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-content a {
  color: rgba(0, 0, 0);
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropdown-content a:hover {
  color: #000;
  background-color: #f8f9fa;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.nav-item {
  padding-left: 5px;
  font-size: 1rem;
}
.nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  color: rgba(0, 0, 0, 0.5) !important;
  font-weight: 100;
  text-decoration: none;
  display: block;
  padding: 0.5rem 1rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out;
}
@media screen and (max-width: 1199px) {
  .dropdown-content {
    position: static;
  }
  .dropdown,
  .nav-link {
    padding-right: 0;
    padding-left: 0;
  }

  .dropdown {
    border: none;
  }
  .dropdown span {
    color: #fff !important;
    font-weight: 600;
    font-size: 1rem;
  }
  svg {
    fill: #ffffff;
  }
}
</style>
